import { Link } from "react-router-dom";
import { Telescope, ArrowRight, Sparkles } from "lucide-react";

const STAR_MAP_URL = "https://customer-assets.emergentagent.com/job_witness-lodge/artifacts/uf2fkdsz_9C8599D1-AF0C-478F-9892-158C5B91F97A.png";

export function UniverseCompactCard() {
    return (
        <section className="ok-container py-10" data-testid="universe-compact-card">
            <Link
                to="/universe"
                className="ok-card overflow-hidden flex flex-col md:flex-row items-stretch hover:border-[var(--ok-accent)] transition group"
                data-testid="universe-compact-link"
            >
                <div className="md:w-2/5 relative overflow-hidden" style={{ minHeight: 200, background: "#03060a" }}>
                    <img
                        src={STAR_MAP_URL}
                        alt="Universe star map"
                        className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-95 group-hover:scale-105 transition duration-700"
                    />
                    {/* a few accent dots to suggest hotspots */}
                    <span className="absolute" style={{ left: "30%", top: "60%", width: 8, height: 8, borderRadius: 999, background: "#c46cff", boxShadow: "0 0 14px #c46cffaa" }} />
                    <span className="absolute" style={{ left: "70%", top: "30%", width: 10, height: 10, borderRadius: 999, background: "#7fb6ff", boxShadow: "0 0 16px #7fb6ffaa" }} />
                    <span className="absolute" style={{ left: "16%", top: "20%", width: 8, height: 8, borderRadius: 999, background: "#ff6b8b", boxShadow: "0 0 14px #ff6b8baa" }} />
                </div>
                <div className="md:w-3/5 p-6 md:p-8 flex flex-col justify-center">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] opacity-50 mb-2 flex items-center gap-2">
                        <Telescope className="w-3 h-3" /> Cosmography · Reported origins
                    </div>
                    <h2 className="font-display text-2xl md:text-3xl mb-2">Universe Explorer</h2>
                    <p className="opacity-80 text-sm max-w-lg mb-4">
                        Explore reported origins, species connections and claimed star systems, from Draco and Zeta Reticuli to interdimensional and inner-Earth theories.
                    </p>
                    <div className="flex items-center gap-3 flex-wrap">
                        <span className="ok-btn-primary text-sm group-hover:translate-x-0.5 transition-transform" data-testid="universe-compact-cta">
                            Open Star Map <ArrowRight className="w-4 h-4" />
                        </span>
                        <span className="font-mono text-[10px] uppercase tracking-widest opacity-50 flex items-center gap-1">
                            <Sparkles className="w-3 h-3" /> 10 systems · 8 species · live links
                        </span>
                    </div>
                </div>
            </Link>
        </section>
    );
}
